import * as React from "react"
import { Logo } from "@/components/Logo"

export function AuthShell({
  children,
  footer,
}: {
  children: React.ReactNode
  footer?: React.ReactNode
}) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-surface px-4 py-12 text-ink-body">
      <Logo className="h-12" />
      <div className="callout bg-page mt-8 w-full max-w-md">{children}</div>
      {footer && <div className="mt-6 text-center text-sm">{footer}</div>}
    </div>
  )
}
